var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.openFreshdesk}},[_c('v-icon',{attrs:{"color":"#fff"}},[_vm._v("mdi-face-agent")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.buttonTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }